import React from 'react';
import PropTypes from 'prop-types';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Overlay from 'core/components/Overlay';

import { Divider } from 'listing/layout';

// Import icons by individual modules for better code splitting
import Close from 'core/icons/Close';
import LinkIcon from 'core/icons/Link';

import {
	BodyText,
	CopyBtn,
	Icon,
	ShareItem,
	Footer,
	ShareButtonsWrapper,
	ShareZoneWrapper,
	ShareZoneHeading,
	ViewWishlistBtn,
	Wrapper,
	DismissBtn,
	Heading,
	Header,
} from './wishlistConfirmationStyles';

class ShareZone extends React.Component {
	timeout = null;
	state = {
		copied: false,
	};

	componentDidMount() {
		this.socialPlugins();
	}

	componentWillUnmount() {
		if (this.timeout) {
			clearTimeout(this.timeout);
		}
	}

	socialPlugins() {
		let twt = document.getElementById('twitter-wjs');
		twt && twt.remove();
		window.twttr = (function(d, s, id) {
			var js, fjs = d.getElementsByTagName(s)[0],
				t = window.twttr || {};
			if (d.getElementById(id)) return t;
			js = d.createElement(s);
			js.id = id;
			js.src = "https://platform.twitter.com/widgets.js";
			fjs.parentNode.insertBefore(js, fjs);

			t._e = [];
			t.ready = function(f) {
				t._e.push(f);
			};

			return t;
		}(document, "script", "twitter-wjs"));

		if (window.FB && window.FB.XFBML && window.FB.XFBML.parse) {
			window.FB.XFBML.parse();
		}
	}

	triggerCopy = () => {
		this.setState({
			copied: true
		});

		this.timeout = setTimeout(() => {
			this.setState({
				copied: false
			});
		}, 2500);
	}

	render() {
		const { customerId, basket } = this.props;
		const domain = typeof window === 'object' ? window.location.hostname : '';
		const shareUrl = `https://${domain}/wishlist/${customerId}`;
		const copyUrl = `${shareUrl}?utm_medium=shr&utm_source=wl&utm_basket=${basket}&utm_carton=dt&utm_egg=link`;
		return (
			<ShareZoneWrapper>
				<ShareZoneHeading>Share you wishlist</ShareZoneHeading>
				<ShareButtonsWrapper>
					<ShareItem id="fb-share-button" className="fb-share-button"
						data-href={`${shareUrl}?utm_medium=shr&utm_source=wl&utm_basket=${basket}&utm_carton=dt&utm_egg=fb`}
						data-layout="button">
					</ShareItem>
					<ShareItem>
						<a className="twitter-share-button"
							href="https://twitter.com/intent/tweet"
							data-text="If you're feeling generous, I'd love any of these subscription boxes :) Check out my wishlist on @Cratejoy!"
							data-url={`${shareUrl}?utm_medium=shr&utm_source=wl&utm_basket=${basket}&utm_carton=dt&utm_egg=tw`}>
							Tweet
						</a>
					</ShareItem>
					<CopyToClipboard text={copyUrl} onCopy={this.triggerCopy}>
						<CopyBtn themeType={'neutral'} size={'sm'}>
							<Icon>
								<LinkIcon fill={'white'} />
							</Icon>
							<div>
								{this.state.copied
									? 'Copied ✅'
									: 'Copy Link'
								}
							</div>
						</CopyBtn>
					</CopyToClipboard>
				</ShareButtonsWrapper>
			</ShareZoneWrapper>
		);
	}
}

ShareZone.defaultProps = {
	basket: 'modal',
};

ShareZone.propTypes = {
	customerId: PropTypes.number,
	basket: PropTypes.string,
};

export default class WishlistConfirmation extends React.Component {
	render() {
		const { show, onClose, customerId } = this.props;
		if (!show || !customerId) return null;

		return (
			<Overlay noCloseBtn dismiss={onClose} noOverflow>
				<Wrapper>
					<Heading>
						<Header>
							Added to your wishlist!
						</Header>
						<DismissBtn onClick={onClose}>
							<Close width="16" height="16" fill="currentColor"/>
						</DismissBtn>
					</Heading>
					<Divider style={{ margin: 0 }}/>
					<BodyText>
						Nice choice! Share your updated Wishlist with friends and family to show them what you really want this year.
					</BodyText>
					<Divider style={{ margin: 0 }}/>
					<Footer>
						<ShareZone customerId={customerId} />
						<ViewWishlistBtn themeType={'neutral'} href={`/wishlist/${customerId}`}>
							{'View wishlist'}
						</ViewWishlistBtn>
					</Footer>
				</Wrapper>
			</Overlay>
		);
	}
}

WishlistConfirmation.propTypes = {
	customerId: PropTypes.number,
	show: PropTypes.bool,
	onClose: PropTypes.func,
};
